










































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Nav from '@/components/navbar/index.vue'
import {
  cvtTimeMillisByDateTimeStr,
  nowTimeMillis,
  startDateTimeStr,
  thisStartMonthDay,
  timeMillis2DateTime
} from '@/utils/time'
import moment from 'moment'
import { add, count, list, update } from '@/api/oj'
import {
  ansLinkFilterArray,
  choices,
  difficulties,
  difficultiesArray,
  importanceFilterArray,
  importances,
  languages,
  problemSet,
  problemSetFilterArray,
  problemType,
  problemTypeArray,
  questionBank,
  standaloneFilterArray,
  statusFilterArray,
  statusSet,
  studyFilterArray,
  useTimeFilterArray
} from '@/constant/ojConstant'
import { IOj, IOjUpdate, ISummary } from '@/types/oj/types'
import { filterEmptyMethod, filterHandlerMethod, filterUseTimeHandler } from '@/utils/table'
import { getUser } from '@/api/user'
import { calUseTimeOk } from '@/utils/oj'
import { USER } from "@/constant/storageConstant";

@Component({
  name: 'Oj',
  components: {
    Nav
  }
})
export default class extends Vue {
  private ojType = 0
  private summaryLoading = false
  private summaryList: ISummary[] = []
  private questionBank = questionBank

  private difficulties = difficulties
  private problemSet = problemSet
  private problemType = problemType
  private choices = choices
  private importances = importances
  private statusSet = statusSet

  private languages = languages
  private ansLinkVisible = true
  private ansLinkList: any = []
  private ansLinkMap: any = {}
  private ansLinkForm: any = {
    'language': '',
    'link': ''
  }
  private createTimeDateTime = ""

  private dateTimeRange: string[] | null = []
  private currentPage = 1
  private pageSizes = ['10', '20', '50', '100', '10000']
  private pageSize = 10
  private pageCount = 5
  private total = 10
  private listLoading = false
  private ojList: any[] = []
  private filterDifficultiesArray = difficultiesArray
  private filterProblemTypeArray = problemTypeArray
  private filterProblemSetArray = problemSetFilterArray
  private filterStandaloneArray = standaloneFilterArray
  private filterStudyArray = studyFilterArray
  private filterAnsLinkArray = ansLinkFilterArray
  private filterStatusArray = statusFilterArray
  private filterImportanceArray = importanceFilterArray
  private filterHandler = filterHandlerMethod
  private filterEmptyMethod = filterEmptyMethod
  private filterUseTimeArray = useTimeFilterArray
  private filterUseTimeHandler = filterUseTimeHandler

  private calShowTime = calUseTimeOk

  private timerId = -1
  private countdownTimer: any | undefined
  private timerUseTime = 0
  private timer = ''

  private addFormVisible = false
  private addLoading = false
  private addForm: any = {}
  private showIdName = true
  private addFormIdName = ''

  private updateFormVisible = false
  private useTimeVisible = true
  private updateLoading = false
  private updateForm: any = {}
  private oldOj: any = {}

  private pid: string = ''

  mounted () {
    this.dateTimeRange = [
      thisStartMonthDay(),
      startDateTimeStr(moment().add(1, 'days'))
    ]

    // html加载完成后执行。执行顺序：子组件-父组件
    const isLogin = localStorage.getItem(USER) !== null
    if (!isLogin) {
      this.getUserAndInitData()
    } else {
      this.searchList()
    }
  }

  beforeDestroy () {
    // 清除定时刷新，不清除会一直运行，关闭页面也会定时刷新
    if (this.countdownTimer !== undefined) {
      clearInterval(this.countdownTimer)
    }
  }

  private updateTimerUseTime () {
    this.timerUseTime++
    this.timer = this.calTimerFormatUseTime(this.timerUseTime) + '(' + this.timerUseTime + '秒)'
  }

  private calTimerFormatUseTime (time: number) {
    const h = parseInt((time / 3600).toString())
    const m = parseInt(((time % 3600) / 60).toString())
    const s = (time % 3600) % 60
    return h + '时' + m + '分' + s + '秒'
  }

  private descOjType = (ojType: number) => {
    for (const t of problemSet) {
      if (ojType === t.value) {
        return t.label
      }
    }
    return ''
  }

  private descImportance = (i: number) => {
    for (const t of importances) {
      if (i === t.value) {
        return t.label
      }
    }
    return ''
  }

  private descStatus = (status: number) => {
    for (const t of statusSet) {
      if (status === t.value) {
        return t.label
      }
    }
    return ''
  }

  private async getUserAndInitData () {
    const result = await getUser()
    if (result.status) {
      localStorage.setItem(USER, JSON.stringify(result.data))
      await this.searchList()
    }
  }

  private resetSearchList () {
    this.dateTimeRange = [thisStartMonthDay(), startDateTimeStr(moment().add(1, 'days'))]
    this.pid = ''
  }

  private async searchList () {
    // 已登录，加载初始数据
    const status = await this.getList()
    if (status) {
      // 获取数据总量
      await this.getTotal()
    }
  }

  private descTime (ts: number) {
    return timeMillis2DateTime(ts)
  }

  private handleSizeChange (val: number) {
    this.pageSize = val
    this.searchList()
  }

  private handleCurrentChange (val: number) {
    this.currentPage = val
    this.searchList()
  }

  private stringToNumber (pid: string) {
    return /^[1-9]+[0-9]*$/.test(pid.trim()) ? parseInt(pid.trim()) : undefined
  }

  private async getList () {
    this.listLoading = true
    const startTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[0]) : undefined
    const endTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[1]) : undefined
    const param = {
      pid: this.stringToNumber(this.pid),
      offset: (this.currentPage - 1) * this.pageSize,
      count: this.pageSize,
      begin: startTime,
      end: endTime
    }
    const result = await list(param)
    // 拉取数据时要清空原来的数据
    this.ojList.splice(0, this.ojList.length)
    if (result.status) {
      for (const t of result.data) {
        if (t.status === 1) {
          this.addTimer(t.id, t.useTime, t.preTime)
        }
        this.ojList.push(t)
      }
    }
    this.listLoading = false
    this.calSummary()
    return result.status
  }

  private descAnsMap (s?: string | undefined) {
    let ansLinks: { language: string; link: string }[] = []
    if (s === undefined || s === '') {
      return ansLinks
    }
    const m = JSON.parse(s)
    for (const l of languages) {
      const link = m[l.label]
      if (link !== undefined && link !== '') {
        ansLinks.push({
          'language': l.label,
          'link': link
        })
      }
    }
    return ansLinks
  }

  private async getTotal () {
    const begin = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[0]) : undefined
    const end = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[1]) : undefined
    const param = {
      pid: this.stringToNumber(this.pid),
      begin: begin,
      end: end
    }
    const result = await count(param)
    if (result.status) {
      this.total = result.data
    }
  }

  private handleLink = (link: string) => {
    window.open(link)
  }

  private handleAdd () {
    this.addForm = {
      'difficulty': '中等',
      'ojType': 1,
      'type': '贪心',
      'importance': 1
    }
    this.addFormVisible = true
  }

  private clearAddInput () {
    this.addForm = {}
    this.showIdName = true
    this.addFormIdName = ''
  }

  private async submitAdd () {
    if (this.timerId > 0) {
      this.$message.error('请先暂停或是完成正在进行中的题目')
      this.addFormVisible = false
      return
    }
    if (this.showIdName) {
      if (!/^[1-9][0-9]*\..+$/.test(this.addFormIdName)) {
        this.$message.error('请填写正确的题目信息')
        return
      }
      const idx = this.addFormIdName.indexOf('.')
      this.addForm.pid = this.addFormIdName.substring(0, idx).trim()
      this.addForm.name = this.addFormIdName.substring(idx + 1).trim()
    }
    if (this.addForm.pid === undefined ||
      this.addForm.name === undefined ||
      this.addForm.difficulty === undefined ||
      this.addForm.ojType === undefined ||
      this.addForm.type === undefined ||
      this.addForm.importance === undefined ||
      this.addForm.link === undefined) {
      this.$message.error('请填写题目信息')
      return
    }

    this.addLoading = true
    const param = {
      pid: this.addForm.pid,
      name: this.addForm.name,
      difficulty: this.addForm.difficulty,
      ojType: this.addForm.ojType,
      type: this.addForm.type,
      preTime: nowTimeMillis(),
      link: this.addForm.link,
      importance: this.addForm.importance
    }
    const result = await add(param)
    if (result.status) {
      const t = result.data
      this.addTimer(t.id, t.useTime, t.preTime)
      this.ojList.unshift(t)
      this.clearAddInput()
      this.$message.success('添加成功')
    }
    this.addLoading = false
    this.addFormVisible = false
  }

  private addTimer (id: number, useTime: number, preTime: number) {
    this.timerId = id
    this.timerUseTime = parseInt((useTime + (nowTimeMillis() - preTime) / 1000).toString())
    if (this.countdownTimer !== undefined) {
      clearInterval(this.countdownTimer)
    }
    const updateTimerUseTime = this.updateTimerUseTime
    this.countdownTimer = setInterval(function () {
      updateTimerUseTime()
    }, 1000)
  }

  private handleEdit (oj: IOj) {
    this.updateFormVisible = true
    this.oldOj = oj
    // 深拷贝
    this.updateForm = JSON.parse(JSON.stringify(oj))
    this.createTimeDateTime = this.descTime(this.updateForm.createTime)
    this.ansLinkList = this.descAnsMap(this.updateForm.ansLink)
    if (this.updateForm.ansLink !== undefined) {
      this.ansLinkMap = JSON.parse(this.updateForm.ansLink)
    }
  }

  private async handleDelete (id: number) {
    this.listLoading = false
    const param: IOjUpdate = {
      id: id,
      preTime: nowTimeMillis(),
      status: 4
    }
    const result = await update(param)
    if (result.status) {
      let idx = -1
      this.ojList.forEach((o, i) => {
        if (o.id === id) {
          idx = i
        }
      })
      if (this.ojList[idx].status === 1) {
        this.clearTimer()
      }
      this.ojList.splice(idx, 1)
      this.timeoutCalSummary()
      this.$message.success('删除记录成功, ID: ' + id)
    }
    this.listLoading = false
  }

  private clearTimer () {
    this.timerId = -1
    clearInterval(this.countdownTimer)
  }

  private handleUseTime () {
    this.useTimeVisible = !this.useTimeVisible
  }

  private clearUpdateInput () {
    this.updateForm = {}
  }

  private async submitUpdate () {
    if (this.createTimeDateTime != null) {
      this.updateForm.createTime = cvtTimeMillisByDateTimeStr(this.createTimeDateTime)
    }
    let needUpdate = false
    for (const key in this.updateForm) {
      if (this.oldOj[key] !== this.updateForm[key]) {
        needUpdate = true
        break
      }
    }
    if (!needUpdate) {
      this.updateFormVisible = false
      this.$message.success('不需要更新')
      return
    }
    const param: IOjUpdate = {
      id: this.updateForm.id,
      preTime: nowTimeMillis()
    }
    if (this.oldOj.status !== this.updateForm.status) {
      if (this.oldOj.status !== 1 && this.updateForm.status === 1 && this.timerId > 0) {
        this.$message.error('请先完成或暂停正在进行中的题目')
        this.updateFormVisible = false
        return
      }
      param.status = this.updateForm.status
    }
    if (this.oldOj.pid !== this.updateForm.pid) {
      param.pid = this.updateForm.pid
    }
    if (this.oldOj.name !== this.updateForm.name) {
      param.name = this.updateForm.name
    }
    if (this.oldOj.difficulty !== this.updateForm.difficulty) {
      param.difficulty = this.updateForm.difficulty
    }
    if (this.oldOj.ojType !== this.updateForm.ojType) {
      param.ojType = this.updateForm.ojType
    }
    if (this.oldOj.type !== this.updateForm.type) {
      param.type = this.updateForm.type
    }
    if (this.oldOj.useTime !== this.updateForm.useTime) {
      param.useTime = this.updateForm.useTime
    }
    if (this.oldOj.standalone !== this.updateForm.standalone) {
      param.standalone = this.updateForm.standalone
    }
    if (this.oldOj.study !== this.updateForm.study) {
      param.study = this.updateForm.study
    }
    if (this.oldOj.link !== this.updateForm.link) {
      param.link = this.updateForm.link
    }
    if (this.oldOj.ansLink !== this.updateForm.ansLink) {
      param.ansLink = this.updateForm.ansLink
    }
    if (this.oldOj.importance !== this.updateForm.importance) {
      param.importance = this.updateForm.importance
    }
    if (this.oldOj.createTime !== this.updateForm.createTime) {
      param.createTime = this.updateForm.createTime
    }
    this.updateLoading = true
    const result = await update(param)
    if (result.status) {
      const newOj = result.data
      if (this.checkNeedUpdate(newOj)) {
        this.timeoutCalSummary()
      }
      const oldStatus = this.oldOj.status
      for (const key in newOj) {
        this.oldOj[key] = newOj[key]
      }
      if (newOj.status === 1) {
        this.addTimer(this.oldOj.id, this.oldOj.useTime, this.oldOj.preTime)
      } else {
        if (oldStatus === 1) {
          this.clearTimer()
        }
      }
      this.$message.success('更新成功')
    }
    this.updateLoading = false
    this.updateFormVisible = false
  }

  private checkNeedUpdate (newOj: any) {
    if (newOj.status === undefined && this.oldOj.status !== 3) {
      return false
    }
    if ((newOj.status === 3 && (this.oldOj.status === 1 || this.oldOj.status === 2)) ||
      (this.oldOj.status === 3 && (newOj.status === 1 || newOj.status === 2))) {
      return true
    }
    return (newOj.difficulty !== undefined && newOj.difficulty !== this.oldOj.difficulty) ||
      (newOj.standalone !== undefined && newOj.standalone !== this.oldOj.standalone) ||
      (newOj.study !== undefined && newOj.study !== this.oldOj.study) ||
      (newOj.ansLink !== undefined && newOj.ansLink !== this.oldOj.ansLink)
  }

  private initSummary (difficulty: string) {
    const s: ISummary = {
      difficulty: difficulty,
      cnt0: 0,
      cnt1: 0,
      cnt2: 0,
      cnt3: 0,
      cnt4: 0,
      total: 0,
      percent: 0
    }
    return s
  }

  private calSummary () {
    this.summaryLoading = true
    const easy: ISummary = this.initSummary('简单')
    const medium: ISummary = this.initSummary('中等')
    const hard: ISummary = this.initSummary('困难')
    this.ojList.forEach(oj => {
      if (oj.status === 3 && (this.ojType === 0 || this.ojType === oj.ojType)) {
        if (oj.study === '否') {
          if (oj.difficulty === '简单') {
            easy.cnt2++
          } else if (oj.difficulty === '中等') {
            medium.cnt2++
          } else {
            hard.cnt2++
          }
        }
        if (oj.ansLink === undefined || oj.ansLink === '') {
          if (oj.difficulty === '简单') {
            easy.cnt3++
          } else if (oj.difficulty === '中等') {
            medium.cnt3++
          } else {
            hard.cnt3++
          }
        }
        if (oj.standalone === '是') {
          if (oj.difficulty === '简单') {
            easy.cnt1++
          } else if (oj.difficulty === '中等') {
            medium.cnt1++
          } else {
            hard.cnt1++
          }
        } else {
          if (oj.difficulty === '简单') {
            easy.cnt0++
          } else if (oj.difficulty === '中等') {
            medium.cnt0++
          } else {
            hard.cnt0++
          }
        }
        if (!calUseTimeOk(oj.difficulty, oj.useTime)) {
          if (oj.difficulty === '简单') {
            easy.cnt4++
          } else if (oj.difficulty === '中等') {
            medium.cnt4++
          } else {
            hard.cnt4++
          }
        }
      }
    })
    easy.total = easy.cnt0 + easy.cnt1
    medium.total = medium.cnt0 + medium.cnt1
    hard.total = hard.cnt0 + hard.cnt1
    easy.percent = this.calPercent(easy.cnt0, easy.total)
    medium.percent = this.calPercent(medium.cnt0, medium.total)
    hard.percent = this.calPercent(hard.cnt0, hard.total)
    this.$set(this.summaryList, 0, easy)
    this.$set(this.summaryList, 1, medium)
    this.$set(this.summaryList, 2, hard)
    this.summaryLoading = false
  }

  private calPercent (s: number, m: number) {
    if (m === 0) {
      return 0
    }
    return Math.round(s / m * 10000) / 100
  }

  private timeoutCalSummary () {
    // 延时计算summary， 解决summary表格不更新的bug,怀疑是vue或是elementUI table的bug
    const ts = this.calSummary
    setTimeout(function () {
      ts()
    }, 1000)
  }

  private handleEditAnsLink () {
    // 如果没有提交，重新设置成旧值
    this.ansLinkForm.link = this.ansLinkMap[this.ansLinkForm.language]
    this.ansLinkVisible = false
  }

  private submitAnsLink () {
    this.ansLinkMap[this.ansLinkForm.language] = this.ansLinkForm.link
    this.updateForm.ansLink = JSON.stringify(this.ansLinkMap)
    this.ansLinkList = this.descAnsMap(this.updateForm.ansLink)
    this.ansLinkVisible = true
  }

  private chooseLanguage () {
    this.ansLinkForm.link = this.ansLinkMap[this.ansLinkForm.language]
  }
}
